import {
  BridgeData,
  CurrencyPreset,
  KycTypePreset,
} from '~/app/settings/team/banks/BanksSimulator/types'

const INCOMPLETE_STATUSES = [
  'incomplete',
  'awaiting_ubo',
  'awaiting_questionnaire',
]

export const deriveStateId = (bridge?: BridgeData): string => {
  if (!bridge) return 'not-started'
  const { kyc, addressCollectionNeeded } = bridge
  if (kyc.tosStatus === 'approved' && kyc.kycStatus === 'approved') {
    return addressCollectionNeeded ? 'address-needed' : 'approved'
  }
  if (kyc.kycStatus === 'rejected') return 'rejected'
  if (kyc.kycStatus === 'paused') return 'paused'
  if (kyc.kycStatus === 'under_review') return 'review'
  if (kyc.tosStatus !== 'approved') return 'tos-incomplete'
  if (INCOMPLETE_STATUSES.includes(kyc.kycStatus)) return 'kyc-incomplete'
  return 'tos-incomplete'
}

export const deriveStageLabel = (bridge?: BridgeData): string => {
  if (!bridge) return 'Not started'
  const { kyc, addressCollectionNeeded } = bridge
  if (kyc.tosStatus === 'approved' && kyc.kycStatus === 'approved') {
    return addressCollectionNeeded ? 'Addr needed' : 'Approved'
  }
  if (kyc.kycStatus === 'rejected') return 'Rejected'
  if (kyc.kycStatus === 'paused') return 'Paused'
  if (kyc.kycStatus === 'under_review') return 'Under review'
  if (kyc.tosStatus !== 'approved') return 'TOS incomplete'
  if (INCOMPLETE_STATUSES.includes(kyc.kycStatus)) return 'KYC started'
  return 'TOS incomplete'
}

export const deriveKycType = (bridge?: BridgeData): KycTypePreset =>
  bridge?.kyc?.kycType ?? 'individual'

export const deriveCurrency = (bridge?: BridgeData): CurrencyPreset => {
  const locales = bridge?.customerLocales?.map((c) => c.locale) ?? []
  if (locales.includes('us') && locales.includes('eu')) return 'both'
  if (locales.includes('eu')) return 'eu'
  return 'us'
}

// Module-scoped flag — components import this to skip API calls during simulation
let _isSimulating = false
export const isSimulating = () => _isSimulating
export const setSimulating = (value: boolean) => {
  _isSimulating = value
}
